module.exports = __webpack_public_path__ + "media/images/pudorys_patro2-eba304b2.svg";